function buildComplexMeta(id, value) {
  if (typeof id === 'undefined') {
    // subcampaign.campaign.id and subcampaign.brandProfile.id are not provided by API
    return value;
  }

  return `#${id} | ${value}`;
}

export function getProfileMeta(profileType, profile) {
  return {
    [`${profileType}Profile`]: profile ? buildComplexMeta(profile.id, profile.name) : 'unknown'
  };
}

export function getCampaignMeta(campaign) {
  if (!campaign) {
    return {};
  }
  return {
    campaign: buildComplexMeta(campaign.id, campaign.name)
  };
}

export function getSubcampaignMeta(subcampaign) {
  if (!subcampaign) {
    return {};
  }
  return {
    subcampaign: buildComplexMeta(subcampaign.id,
      subcampaign.offer?.type ? `${subcampaign.offer.type}, ${subcampaign.offer.budget || 'n/a'}€` : 'n/a'
    )
  };
}

export function getMetaForCampaign(campaign) {
  if (!campaign) {
    return {};
  }
  return {
    ...getCampaignMeta(campaign),
    brandProfileId: campaign ? campaign.brandProfileId : null
  };
}

export function getMetaForSubcampaign(subcampaign) {
  return {
    ...getSubcampaignMeta(subcampaign),
    ...getProfileMeta('influencer', subcampaign ? subcampaign.creatorProfile : null)
  };
}
